import get from "lodash.get";
import * as validationInfo from "./validationInfo";

const traverse = (document, propertyPath, validationRulesObj, filterPathFunc) => {
  let entries = Object.entries(validationRulesObj || {}).map(([prop, fnOrObj]) => [
    prop,
    typeof fnOrObj === "function" ? fnOrObj(document, get(document, combinePath(propertyPath, prop))) : fnOrObj
  ]);

  if (filterPathFunc) {
    entries = entries.filter(([prop]) => filterPathFunc(combinePath(propertyPath, prop)));
  }

  const result = entries
    .map(([prop, validationRulesArrayOrObj]) => {
      const validationResult = Array.isArray(validationRulesArrayOrObj)
        ? applyRules(document, combinePath(propertyPath, prop), validationRulesArrayOrObj)
        : traverse(document, combinePath(propertyPath, prop), validationRulesArrayOrObj, filterPathFunc);
      return [prop, validationResult];
    })
    .reduce((accumulator, [prop, validationResult]) => {
      return validationInfo.update(prop, validationResult, accumulator);
    }, validationInfo.create(true));
  return result;
};

const applyRules = (document, propertyPath, validationRulesArray) => {
  const valueToValidate = get(document, propertyPath);
  const failedValidation = validationRulesArray
    .map(fnOrValidationRule =>
      typeof fnOrValidationRule === "function"
        ? fnOrValidationRule(document, valueToValidate, null)
        : fnOrValidationRule
    )
    .find(validation => validation && !validation.func(valueToValidate, document));

  const result = failedValidation ? failedValidation.msg : "";

  return result;
};

const combinePath = (left, right) => (left ? `${left}.${right}` : right);

const validate = function(document, validationRules, filterPathFunc) {
  const result = traverse(document, null, validationRules, filterPathFunc);
  return result;
};

const validationEngine = { validate };
export default validationEngine;